import CryptoJS from 'crypto-js';

/**
 * BASE64加密
 * @param data 数据
 */
const Base64 = {
  en: (data) => CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data)),
  de: (data) => CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)
};

/**
 * MD5加密
 * @param data 数据
 */
const MD5 = (data) => {
  return CryptoJS.MD5(data).toString();
};

export {
  Base64,
  MD5
};